export default __webpack_public_path__ + "static/media/D2015_09_15_San_Jose.173faab9.jpg";